export default "__VITE_ASSET__9fvQrwM3__"